export const somethingWentWrong =
  'Something went wrong while <action>. Try again or escalate to Chkk';

export const toastAutoHideDuration = 5000;
